export const LimitFiles = {
  'DEFAULT': 1,
  'MULTIPLE_FILES': 100
};